import { render, staticRenderFns } from "./NeoparentPatients.vue?vue&type=template&id=0ad8f857&scoped=true"
import script from "./NeoparentPatients.vue?vue&type=script&lang=js"
export * from "./NeoparentPatients.vue?vue&type=script&lang=js"
import style0 from "./NeoparentPatients.vue?vue&type=style&index=0&id=0ad8f857&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad8f857",
  null
  
)

export default component.exports